<template lang="pug">
// Card css types: green, yellow, blue and red;
.card-dashboard(:class="['card-dashboard-' + cardType, {'clickable': clickable }]")
    .card-dashboard-title
        span {{title}}
        slot(name="title")
    .card-dashboard-content
        .content-text
            span {{content}}
        .card-dashboard-icon
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: Number,
      required: true
    },
    cardType: {
      type: String
    },
    clickable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.card-dashboard {
  display: flex;
  width: auto;
  height: 100%;
  border: 2px solid;
  flex-flow: column;
  padding: 20px 20px;
  border-radius: 12px;
  box-shadow: 0px 3px 6px #00000029;
}

.card-dashboard-content {
  display: flex;
  flex-flow: row;
  height: 100%;
  align-items: flex-end;
}

.card-dashboard-title {
  font-size: 18px;
  color: #8D8D8D;
  padding-bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.content-text {
  width: 40%;
  font-size: 41px;
  color: black;
}

.card-dashboard-icon {
  font-size: 41px;
  padding: 20px;
  width: 100%;
}

.card-dashboard-green {
  border-color: #1ABC9C;
  .card-dashboard-icon {
    background: transparent url('~@/assets/icons/bandeira.svg') 0% 0% no-repeat padding-box;
    background-position-x: right;
    height: 54px;
  }
}

.card-dashboard-yellow {
  border-color: #F1C40F;
  .card-dashboard-icon {
    background: transparent url('~@/assets/icons/pasta.svg') 0% 0% no-repeat padding-box;
    height: 54px;
    background-position-x: right;
  }
}

.card-dashboard-blue {
  border-color: #3498DB;
  .card-dashboard-icon {
    background: transparent url('~@/assets/icons/relatorio.svg') 0% 0% no-repeat padding-box;
    height: 59px;
    background-position-x: right;
  }
}

.card-dashboard-red {
  border-color: #E74C3C;
  .card-dashboard-icon {
    background: transparent url('~@/assets/icons/caixa.svg') 0% 0% no-repeat padding-box;
    height: 50px;
    background-position-x: right;
  }
}

.clickable {
  cursor: pointer;

  &.card-dashboard-green:hover {
    background-color: rgba(26, 188, 156, 0.041);
  }
  &.card-dashboard-yellow:hover {
    background-color: rgba(241, 196, 15, 0.041);
  }
  &.card-dashboard-blue:hover {
    background-color: rgba(52, 152, 219, 0.041);
  }
  &.card-dashboard-red:hover {
    background-color: rgba(231, 76, 60, 0.041);
  }
}

@media only screen and (max-width: 1256px) {
  .card-dashboard-title {
    font-size: 14px;
  }

  .card-dashboard-content {
    flex-flow: column;
  }

  .content-text {
    font-size: 25px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/relatorios/components/gerais/AppCardDashboard.vue